import { render } from "./3.HelpWithYou.vue?vue&type=template&id=3c56a1e2&scoped=true"
import script from "./3.HelpWithYou.vue?vue&type=script&lang=js"
export * from "./3.HelpWithYou.vue?vue&type=script&lang=js"

import "./3.HelpWithYou.vue?vue&type=style&index=0&id=3c56a1e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c56a1e2"]])

export default __exports__